export const ArpeggioRightOptionsCard = props => {
  const imgSrc = props.imgSrc
  
  let writeBtn = ""
  if (!props.writeModeState) {
    writeBtn = 
      <div className="arpeggioWriteContainer pointerHover" id="arpeggioWriteContainer" data-action="toggleWriteActive" title="N">
        <img draggable="false" src={imgSrc[28]} className="arpeggioFullImage noContextMenu" alt="toggleWriteActive up" onClick={props.handleClick} />
      </div>
  }
  else {
    writeBtn =
      <div className="arpeggioWriteContainer pointerHover" id="arpeggioWriteContainer" data-action="toggleWriteActive" title="N">
        <img draggable="false" src={imgSrc[27]} className="arpeggioFullImage noContextMenu" alt="toggleWriteActive down" onClick={props.handleClick} />
      </div>
  }

  let playBtn = ""
  if (!props.playActive) {
    playBtn = 
      <div className="arpeggioPlayContainer pointerHover" id="arpeggioPlayContainer" data-action="playSequence" title="B">
        <img draggable="false" src={imgSrc[20]} className="arpeggioFullImage noContextMenu" alt="play up" onClick={props.handleClick} />
      </div>
  }
  else {
    playBtn = 
      <div className="arpeggioPlayContainer pointerHover" id="arpeggioPlayContainer" data-action="playSequence" title="B">
        <img draggable="false" src={imgSrc[19]} className="arpeggioFullImage noContextMenu" alt="play down" onClick={props.handleClick} />
      </div>
  }
  
  return (
    <div className="arpeggioRightOptionsContainer">
      

      {writeBtn}
      {playBtn}
      
      <div className="arpeggioWipeContainer pointerHover" id="arpeggioWipeContainer" data-action="wipeAll" title="M">
        <img draggable="false" src={imgSrc[26]} className="arpeggioFullImage visible noContextMenu" alt="wipeAll up" onClick={props.handleClick} />
        <img draggable="false" src={imgSrc[25]} className="arpeggioFullImage hidden noContextMenu" alt="wipeAll down" onClick={props.handleClick} />
      </div>
      <div className="arpeggioNftLinkContainer pointerHover" id="arpeggioNftLinkContainer" data-action="nftLink" title="Comma">
        <img draggable="false" src={imgSrc[18]} className="arpeggioFullImage visible noContextMenu" alt="nftLink up" onClick={props.handleClick} />
        <img draggable="false" src={imgSrc[17]} className="arpeggioFullImage hidden noContextMenu" alt="nftLink down" onClick={props.handleClick} />
      </div>

      <div className="arpeggioArrowUpContainer pointerHover" id="arpeggioArrowUpContainer" data-action="moveCursor" data-direction="up" title="Up Arrow">
        <img draggable="false" src={imgSrc[9]} className="arpeggioFullImage visible noContextMenu" alt="arrowUp up" onClick={props.handleClick} />
        <img draggable="false" src={imgSrc[8]} className="arpeggioFullImage hidden noContextMenu" alt="arrowUp down" onClick={props.handleClick} />
      </div>
      <div className="arpeggioArrowRightContainer pointerHover" id="arpeggioArrowLeftContainer" data-action="moveCursor" data-direction="left" title="Right Arrow">
        <img draggable="false" src={imgSrc[7]} className="arpeggioFullImage visible noContextMenu" alt="arrowLeft up" onClick={props.handleClick} />
        <img draggable="false" src={imgSrc[6]} className="arpeggioFullImage hidden noContextMenu" alt="arrowLeft down" onClick={props.handleClick} />
      </div>
      <div className="arpeggioArrowLeftContainer pointerHover" id="arpeggioArrowRightContainer" data-action="moveCursor" data-direction="right" title="Left Arrow">
        <img draggable="false" src={imgSrc[5]} className="arpeggioFullImage visible noContextMenu" alt="arrowRight up" onClick={props.handleClick} />
        <img draggable="false" src={imgSrc[4]} className="arpeggioFullImage hidden noContextMenu" alt="arrowRight down" onClick={props.handleClick} />
      </div>
      <div className="arpeggioArrowDownContainer pointerHover" id="arpeggioArrowDownContainer" data-action="moveCursor" data-direction="down" title="Down Arrow">
        <img draggable="false" src={imgSrc[3]} className="arpeggioFullImage visible noContextMenu" alt="arrowDown up" onClick={props.handleClick} />
        <img draggable="false" src={imgSrc[2]} className="arpeggioFullImage hidden noContextMenu" alt="arrowDown down" onClick={props.handleClick} />
      </div>
      <div className="arpeggioActivatePadContainer pointerHover" id="arpeggioActivatePadContainer" data-action="activatePad" title="Space Bar">
        <img draggable="false" src={imgSrc[1]} className="arpeggioFullImage visible noContextMenu" alt="activatePad up" onClick={props.handleClick} />
        <img draggable="false" src={imgSrc[0]} className="arpeggioFullImage hidden noContextMenu" alt="activatePad down" onClick={props.handleClick} />
      </div>
    </div>
  )
}